import { Col,Row,Container,Card,CardBody,CardHeader} from "reactstrap"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  CartesianGrid,
} from "recharts";
import BarChar1 from "./BarChart1";
import HighChart from "./HighChart";
import BarChart2 from "./BarChart2";
import PieCharts from "./PieChart";
import LoadingChart from "./ProgressBar";
const Dashboard = () =>{
     
    return(
        <Container fluid='true' style={{height:'100%', paddingTop:'18px'}}>
         <Row>
             <Col xl={8}>
               <BarChar1/>
                
             </Col>

             <Col xl={4}>
               <HighChart/>
             </Col>
         </Row>
           <Row>
              <Col xl={6}>
                 <BarChart2/>
              </Col>
              <Col md={3}>
                 <PieCharts/>
              </Col>
              <Col md={3}>
                <LoadingChart/>
              </Col>
           </Row>
         </Container>
    )
}

export default Dashboard;